import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';

/**
 * Plain internal link. The page fade is handled passively by PageCurtain on route
 * change, so this component intentionally does nothing special and never blocks clicks.
 */
export default function TransitionLink(props: LinkProps) {
  return <Link {...props} />;
}